import { Error } from '../error';
import { Collapsible } from '../collapsible';
import { PatternInput } from './input/PatternInput';
import { StartUrlsInput } from './input/StartUrlsInput';
import { AIInput } from './input/AIInput';
import { ProxyInput } from './input/ProxyInput';
import { VisiterInput } from './input/VisiterInput';
import { PriorityInput } from './input/PriorityInput';
import { TemplateInput } from './input/TemplateInput';
import { ExtractOptionsInput } from './input/ExtractOptionsInput';
import { CrawlOptionsInput } from './input/CrawlOptionsInput';
import { Required } from './Required';
import { Optional } from './Optional';
import { paramsInputsStyle } from './shared';
import { Inner } from './Inner';

export const RunScrape = (props) => {
  const renderChildren = (params, onChange, setParams, errors) => {
    return (
      <div style={paramsInputsStyle}>
        <Required style={paramsInputsStyle} slim={props.hideAdvanced}>
          <PatternInput params={params} onChange={onChange} errors={errors} />
          <TemplateInput params={params} onChange={onChange} errors={errors} />
        </Required>

        <Optional style={paramsInputsStyle} hide={props.hideAdvanced}>
          <Collapsible label="Start URLs" value={params.startUrls}>
            <StartUrlsInput noLabel params={params} onChange={onChange} errors={errors} />
          </Collapsible>

          <Collapsible label="Crawl Rules" value={params.priority}>
            <PriorityInput params={params} onChange={onChange} errors={errors} />
          </Collapsible>

          <div style={{ display: 'flex', gap: 10 }}>
            <VisiterInput params={params} onChange={onChange} errors={errors} />
            <ProxyInput params={params} onChange={onChange} errors={errors} />
            <AIInput params={params} onChange={onChange} errors={errors} />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <CrawlOptionsInput params={params} onChange={onChange} errors={errors} />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <ExtractOptionsInput params={params} onChange={onChange} errors={errors} />
          </div>
        </Optional>
      </div>
    );
  };

  const examples = [
    {
      name: 'pokemondb.net',
      params: {
        pattern: 'https://pokemondb.net/pokedex/*',
        template: 'pokemon name, number and basic stats.',
        maxVisits: 20,
        maxExtracts: 100,
      },
    },
  ];

  return (
    <Inner
      endpoint="scrape"
      required={['pattern', 'template']}
      initialParams={props.params}
      examples={examples}
      renderChildren={renderChildren}
      {...props}
    />
  );
};
